import React from 'react';

type Props = {
  blendMode?: boolean;
  block?: boolean;
  zIndex?: number;
  ariaLabel?: string;
  color?: string;
};

export const AdaptiveLogo = ({ blendMode = true, block = false, zIndex, ariaLabel, color = 'text-white' }: Props) => {
  const blendModeClass = blendMode ? 'mix-blend-exclusion' : 'mix-blend-normal';
  const positionClass = block
    ? 'flex h-20 w-20 items-center justify-center p-2.5'
    : 'fixed left-5 top-[18px] flex h-20 w-20 items-center justify-center p-2.5';
  return (
    <div
      className={`${positionClass} ${color} ${blendModeClass}`}
      style={{ zIndex: block ? undefined : (zIndex ?? 11) }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 44 34"
        className="w-[24px] desktop:w-[36px] desktop4k:w-[64px]"
        aria-label={ariaLabel || 'All Turtles Home'}
      >
        <title>All Turtles</title>
        <path
          fill="currentColor"
          style={{ transition: 'all 500ms ease' }}
          d="M12.3373 0.799842C9.83294 1.44741 8.14898 5.59188 9.55228 9.0456L9.46592 9.23987L2.4926 7.51301C2.75167 3.7355 6.3139 0.583984 12.2941 0.583984L12.3373 0.799842Z"
        />
        <path
          fill="currentColor"
          style={{ transition: 'all 500ms ease' }}
          d="M24.6214 9.08868V20.637C24.6214 23.448 25.1312 23.9757 25.6553 24.5183L25.7009 24.5656C26.0263 24.891 26.3347 25.0802 26.578 25.2293C26.722 25.3176 26.8432 25.392 26.9315 25.4723V25.5586H23.6499C19.181 25.5586 16.0073 23.4216 16.0505 17.8309L15.9857 6.36887C15.9857 4.23188 15.3381 1.33939 13.395 0.799751L13.4382 0.60548C20.8001 0.778166 24.6214 3.26053 24.6214 9.08868Z"
        />
        <path
          fill="currentColor"
          style={{ transition: 'all 500ms ease' }}
          d="M0.398438 19.5795C0.398438 26.7459 11.2578 27.6741 14.7337 21.1121L14.6689 21.0257C12.2941 22.99 8.4728 21.1768 8.4728 17.6367C8.4728 14.4421 10.8692 12.4778 14.7553 11.8086L14.812 11.8006C14.9489 11.7814 15.1004 11.7601 15.2518 11.7223V11.0099C15.1007 11.0315 14.928 11.0531 14.7553 11.0747C4.37085 12.3482 0.398438 15.0465 0.398438 19.5795Z"
        />
        <path
          fill="currentColor"
          style={{ transition: 'all 500ms ease' }}
          d="M43.4473 10.0602L39.4749 10.5567C39.0863 10.5567 38.7624 10.8805 38.8056 11.269V28.516C38.8056 31.3487 39.336 31.8766 39.8416 32.3797C39.8561 32.3941 39.8706 32.4086 39.8851 32.423C40.2105 32.7484 40.519 32.9376 40.7622 33.0867C40.9062 33.1751 41.0274 33.2494 41.1157 33.3296V33.416H37.8341C33.3651 33.416 30.1699 31.279 30.2131 25.6883V10.7725C30.2131 10.7725 28.119 10.8373 25.4203 10.9668V10.1034C25.4527 10.1034 25.4851 10.098 25.5175 10.0926C25.5498 10.0872 25.5822 10.0818 25.6146 10.0818C31.7675 9.26154 36.5604 5.851 38.3091 0.951038H38.784V9.39106H43.5984L43.4473 10.0602Z"
        />
      </svg>
    </div>
  );
};
